// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hearingInvitationEntity from './entities/hearing-invitation.json';
import hearingInvitationMenu from '../pages/hearing-invitation/menu.json';
import hearingInvitationFullForm from '../pages/hearing-invitation/forms/full.json';
import hearingInvitationContextForm from '../pages/hearing-invitation/forms/context.json';
import hearingInvitationMiniForm from '../pages/hearing-invitation/forms/mini.json';
import hearingInvitationLookupForm from '../pages/hearing-invitation/forms/lookup.json';
import hearingInvitationTableView from '../pages/hearing-invitation/views/table.json';
import hearingInvitationCardsView from '../pages/hearing-invitation/views/cards.json';
import hearingInvitationCalendarView from '../pages/hearing-invitation/views/calendar.json';
import hearingInvitationDashboardView from '../pages/hearing-invitation/views/dashboard.json';

/** Тип запису «Запрошення» зі сторінками пакета: меню, форми та подання з pages/hearing-invitation/. */
export const hearingInvitationDefinition: IRecordTypeDefinition = {
  ...hearingInvitationEntity,
  views: assembleViewSet({
      table: hearingInvitationTableView,
      cards: hearingInvitationCardsView,
      calendar: hearingInvitationCalendarView,
      dashboard: hearingInvitationDashboardView,
  }),
  form: hearingInvitationFullForm,
  forms: { full: hearingInvitationFullForm, context: hearingInvitationContextForm, mini: hearingInvitationMiniForm, lookup: hearingInvitationLookupForm },
  menu: hearingInvitationMenu,
} as IRecordTypeDefinition;
